<app-base-menu-layout [menuOptions]="menuOptions">
    <ng-container content>
        <router-outlet></router-outlet>
    </ng-container>
</app-base-menu-layout>
